export default from './comment-avatar';



// WEBPACK FOOTER //
// ./app/components/comment-avatar/index.js